import React, { useEffect } from 'react'
import { Modal, Form, Input } from 'antd'
import { useAppDispatch, useAppSelector } from '~/Store/hooks'
import { RolesActions } from '~/Store/Role'
import {
  getRoleModalVisibility,
  getSystemRoleSelected,
} from '~/Store/Role/selectors'
import { roleModalName } from './constant'
import { useTranslation } from 'react-i18next'

export const RoleModal = () => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const dispatch = useAppDispatch()
  const visible = useAppSelector(getRoleModalVisibility(roleModalName))
  const role = useAppSelector(getSystemRoleSelected)

  const handleOk = () => {
    form
      .validateFields()
      .then(values => {
        const trimmedName = values.name?.trim()
        if (role?.id && role?.name) {
          if (role.name !== trimmedName) {
            dispatch(
              RolesActions.updateRoleRequest({
                roleName: role.name,
                newRolename: trimmedName,
                type: 'User',
              }),
            )
          }
        } else {
          dispatch(
            RolesActions.addRolesRequest({ roleName: trimmedName, type: 'User' }),
          )
        }
        dispatch(RolesActions.setSystemRoleSelected({}))
        dispatch(
          RolesActions.setModalState({ name: roleModalName, value: false }),
        )
        form.resetFields()
      })
      .catch(() => {})
  }

  const handleCancel = () => {
    dispatch(RolesActions.setSystemRoleSelected({}))
    dispatch(RolesActions.setModalState({ name: roleModalName, value: false }))
    form.resetFields()
  }

  useEffect(() => {
    form.setFieldsValue(role || {})
  }, [role, form])

  return (
    <Modal
      title={role?.id ? t('editRole') : t('newRole')}
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      okText={t('save')}
      cancelText={t('cancel')}
    >
      <Form form={form} layout="vertical" name="roleForm">
        <Form.Item
          name="name"
          label={t('roleName')}
          normalize={(value) => value?.trimStart()}
          rules={[{ required: true, message: t('fieldRequired') }]}
        >
          <Input placeholder={t('roleManagement.enterRoleName')} />
        </Form.Item>
      </Form>
    </Modal>
  )
}
